/**
 * Import reducers from shared ducks modules (default export)
 * We are following Ducks module proposition:
 * https://github.com/erikras/ducks-modular-redux
 */

import Auth from './Auth.duck';
import EmailVerification from './EmailVerification.duck';
import FlashNotification from './FlashNotification.duck';
import Routing from './Routing.duck';
import UI from './UI.duck';
import user from './user.duck';
import Languages from './Languages.duck';
import Toast from './Toast.duck';
import GuardianReducer from './GuardianReducer.duck';
export {
    Auth,
    EmailVerification,
    FlashNotification,
    Routing,
    UI,
    user,
    Languages,
    Toast,
    GuardianReducer,
};
